module.exports = __webpack_public_path__ + "static/tm1NextBG-fe6162412c08c66704ba82f42f39f9da.jpg";